import {
    Button,
    makeStyles,
    TextField,
    Typography,
    IconButton,
    Grid,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
    member as v_member,
    basic,
    Values,
    SNACKBAR_TIME,
    member,
} from '../request/values';

import React, { Fragment, useState } from 'react';
import { COLORS } from './Theme';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { SIcon } from './Icon';
import CheckIcon from '@material-ui/icons/Check';

import useFixedButtonStyles from './commonStyles/headerEmpty/useFixedButtonStyles';
import useCommonStyles from './commonStyles/headerEmpty/useCommonStyles';

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    submit: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    animation: {
        width: '5vw',
        borderWidth: 3,
        borderColor: `${COLORS.SLATE_GREY}`,
        fontSize: 0,
        borderLeftColor: `${COLORS.WATER_BLUE}`,
        animation: 'rotating 2s 0.25s linear infinite',
        '&:after': {
            content: '',
        },
    },
    testBtn: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
        '&:after': {
            content: '이메일 인증 요청하기',
        },
    },
}));

const SERVER = basic.server;

const FindPassword: React.FC<any> = (props) => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();
    const commonClasses = useCommonStyles();
    let history = useHistory();

    const [email, setEmail] = useState<string>('');
    const [memberName, setMemberName] = useState<string>('');
    const [auth, setAuth] = useState<boolean>(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const buttonText = ['ID 확인하기', '비밀번호 변경하기'];

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        if (id === 'member_email') {
            if (!auth) setEmail(value);
        } else if (id === 'member_name') {
            if (!auth) setMemberName(value);
        }
    };

    const getAuth = () => {
        let url = new URL(SERVER + v_member.member + v_member.auth_pwd_info);
        let params = { email: email, name: memberName };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.AUTH_ID_SUCCSESS_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    setAuth((prevState) => true);
                } else if (data.code == Values.FAIL_CODE) {
                    // this is success == dont exist same id
                    enqueueSnackbar(ToastStr.AUTH_ID_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME * 2,
                        translate: 'no',
                    });
                }
            });
    };

    const movePassword = () => {
        // setMember({ id : email})
        history.push({
            pathname: '/setPassword',
            // search: '?update=true',  // query string
            state: {
                // location state
                email: email,
                name: memberName,
            },
        });
    };

    const moveFindId = () => {
        history.push({
            pathname: '/findId',
        });
    };

    const moveLogin = () => {
        history.push({
            pathname: '/',
        });
    };

    const handleButton = (e: any) => {
        if (auth) {
            movePassword();
        } else {
            // setAnimation(true);
            if (email.length == 0) {
                enqueueSnackbar(ToastStr.ID_ADDR_CHECK_STR, {
                    variant: 'warning',
                    autoHideDuration: SNACKBAR_TIME,
                    translate: 'no',
                });
            } else if (email.length > 32) {
                enqueueSnackbar(ToastStr.ID_ADDR_CHECK_LEN, {
                    variant: 'warning',
                    autoHideDuration: SNACKBAR_TIME,
                    translate: 'no',
                });
            } else if (memberName.length == 0) {
                enqueueSnackbar(ToastStr.NAME_ET_CHECK_STR, {
                    variant: 'warning',
                    autoHideDuration: SNACKBAR_TIME,
                    translate: 'no',
                });
            } else {
                getAuth();
            }
        }
    };

    return (
        <div>
            <div className={fixedButtonClasses.fixedButton}>
                <IconButton onClick={() => moveLogin()}>
                    <SIcon type="Back" />
                </IconButton>
            </div>
            <div className={commonClasses.paper}>
                <div className={commonClasses.titleLeft}>
                    비밀번호 변경을 위해
                    <br />
                    회원가입 정보를 입력해주세요.
                </div>

                <div className={commonClasses.form}>
                    <TextField
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                        id="member_email"
                        label="가입한 ID를 입력하세요."
                        name="email"
                        autoComplete="email"
                        autoFocus
                        InputProps={{ className: commonClasses.inputProps }}
                        InputLabelProps={{
                            className: commonClasses.inputLabel,
                        }}
                        value={email}
                        onChange={valueChangeHandler}
                        style={{ color: `${COLORS.CHARCOAL_GREY}` }}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="member_name"
                        label="가입한 이름을 입력하세요."
                        name="name"
                        autoComplete="name"
                        //autoFocus
                        InputProps={{ className: commonClasses.inputProps }}
                        InputLabelProps={{
                            className: commonClasses.inputLabel,
                        }}
                        value={memberName}
                        onChange={valueChangeHandler}
                        style={{ color: `${COLORS.CHARCOAL_GREY}` }}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                        onClick={handleButton}
                    >
                        {auth && (
                            <CheckIcon
                                style={{
                                    marginRight: '2vw',
                                    color: `${COLORS.WHITE}`,
                                }}
                            />
                        )}
                        <Typography variant="h3">
                            {auth ? buttonText[1] : buttonText[0]}
                        </Typography>
                    </Button>
                    <Button
                        onClick={moveFindId}
                        style={{ marginTop: '1vh', width: '100%' }}
                    >
                        <Typography
                            style={{
                                color: `${COLORS.DOWN}`,
                                fontSize: '16px',
                            }}
                        >
                            아이디 검색하기
                        </Typography>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default FindPassword;
